import React, { Suspense } from 'react';
import Footer from '../../components/layout/Footer';
import { isLandingHost, landingByPageKey, landingByPath, landingWwwPaths, LANDING_PRIMARY_HOST } from './landings/landingRegistry';
import { resolveLandingRoute } from './landings/resolveLandingRoute';
import { isExamHost } from '../examens/examHosts';

/**
 * Prerendered marketing routes (LAND3 R3). The prerender writes this exact tree
 * with eager pages; the client renders it with lazy pages and hydrates (R1, D-2).
 */
export const MARKETING_PATHS = Object.freeze(['/', '/avance-immediate', ...landingWwwPaths(), '/fonctionnalites', '/demonstration', '/contact']);

const TRAILING_SLASH = /\/+$/;
const normalize = (pathname) => (pathname.replace(TRAILING_SLASH, '') || '/');

export const isMarketingPath = (pathname, hostname = LANDING_PRIMARY_HOST) => {
  const path = normalize(pathname);
  if (isLandingHost(hostname) || isExamHost(hostname)) return false;
  if (landingByPath(path)) return Boolean(resolveLandingRoute({ hostname, pathname: path })) && MARKETING_PATHS.includes(path);
  return MARKETING_PATHS.includes(path);
};

/**
 * `pages` maps each marketing path to its page component (lazy on the client,
 * eager on the server). Same wrapper as App's StandalonePage: one Suspense.
 */
export default function MarketingShell({ path, pages, fallback = null }) {
  const Page = pages[normalize(path)];
  return (
    <div className="App App--standalone">
      <Suspense fallback={fallback}>
        <Page />
      </Suspense>
      {normalize(path) === '/' || landingByPageKey(normalize(path))?.ownsFooter ? null : <Footer />}
    </div>
  );
}
